export const VoiceCampaignMedium = {
	VOICE: 'VOICE',
} as const;

export const VoiceCampaignType = {
	DEFAULT: 'DEFAULT',
	EXTERNAL: 'EXTERNAL',
	RETARGET: 'RETARGET',
} as const;

export const RETARGET_OUTCOMES = ['ENGAGED', 'NOT_REACHABLE', 'FAILED'] as const;
export type RetargetOutcome = (typeof RETARGET_OUTCOMES)[number];
export const RETARGET_OUTCOME_TRANSLATION_KEYS: Record<RetargetOutcome, string> = {
	ENGAGED: 'pages:voiceCampaign.retarget.outcomes.engaged',
	NOT_REACHABLE: 'pages:voiceCampaign.retarget.outcomes.notReachable',
	FAILED: 'pages:voiceCampaign.retarget.outcomes.failed',
};

export const VoiceCampaignSort = {
	TRIGGER_START_AT_DESC: 'triggerStartAt,desc',
} as const;

export const VoiceCampaignChannel = {
	WHATSAPP: 'WHATSAPP',
	TELEPHONY: 'TELEPHONY',
} as const;

export const VoiceCampaignChannelOption = {
	WHATSAPP: 'whatsapp',
	TELEPHONY: 'telephony',
} as const;

export const VoiceCampaignContactPlatform = {
	DIALOG360: 'DIALOG360',
	TELEPHONY: 'TELEPHONY',
} as const;
